import React from "react";
import display from "../../api/display.js";
import './display.css'
import SingleApp from "../application/application";
import LoadingAnimation from '../loading-animation/loading-animation'

  function AppList(props) {
    if(props.apps && props.apps.length > 0){
      const apps = props.apps;
      const listApps = apps.map((app) =>
        <SingleApp key={app.id} id={app.id}/>
      );
      return (
        <ul>{listApps}</ul>
      );
    } else {
      return null;
    }
  }

class SingleDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: {name:'loading'},
      id: props.match.params.id,
      loading: true
  };
}

  getDisplayFromApi(id){
    display.getSingleDisplay(id)
    .then((display)=> {
      this.setState({
        loading:false,
        display: display.data.data
      })
    })
    .catch((error)=>{
      console.log(error)
      this.setState({
        loading:false,
        errorMessage:error.message
      })
    });
  }

  componentDidMount(){
    if(this.state.id){
      this.getDisplayFromApi(this.state.id);
    }
  };


  render() {

    let loadingDisplay;
    if(!this.state.display.apps){
      loadingDisplay = (
        <div className="bb-display-loader-container">
          <LoadingAnimation/>
        </div>
      )
    }

    return (
      <div>
        <AppList apps={this.state.display.apps}></AppList>
        {loadingDisplay}
      </div>
    );
  }
}

export default SingleDisplay;



// WEBPACK FOOTER //
// ./src/components/display/display.js